// src/components/searchbar.js
// filepath: /c:/Users/IKUO/Documents/GitHub/newcookle/src/components/searchbar.js
import React, { useEffect, useState } from 'react';
import './searchbar.css';
import { db, dbtime } from "./firebase/index";
import axios from 'axios'; // axios のインポートを確認

const Searchbar = ({ data, clearSelection, str, setStr }) => { // 変更
  const [selectedSite, setSelectedSite] = useState("Pro");
  const [suggestions, setSuggestions] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // ドロップダウンの状態を管理

  useEffect(() => {
    const savedSite = localStorage.getItem("selectedsite");
    if (savedSite) {
      setSelectedSite(savedSite);
    } else {
      setSelectedSite("Pro");
    }
  }, []);
  useEffect(() => {
    if (selectedSite === "KyounoRyouri" || selectedSite === "OrangePage"|| selectedSite === "Siro") {
      setIsDropdownOpen(true);
    }
  }, [selectedSite]);

  const onChange = (e) => {
    setStr(e.target.value); // 変更
  };

  const handleOptionChange = (e) => {
    setSelectedSite(e.target.value);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };


const search = () => {
  if (!str.trim() && data.length === 0) return;

  localStorage.setItem("selectedsite", selectedSite);

  const mappedword = data.join(' ');
  let url = 'https://www.google.co.jp/search?q=' + encodeURIComponent(`${str} ${mappedword}`);

  switch (selectedSite) {
    case "Cookpad":
      url += ' inurl:/recipes site:cookpad.com';
      break;
    case "Kurashiru":
      url += ' inurl:/recipes site:www.kurashiru.com';
      break;
    case "Siro":
      url += ' site:sirogohan.com/ inurl:recipe -の検索結果';
      break;
    case "Nadia":
      url += ' site:oceans-nadia.com/ inurl:recipe';
      break;
    case "Pro":
      url += ' site:kurashiru.com/recipes OR site:kyounoryouri.jp/recipe/ OR site:oceans-nadia.com/user/ OR site:sirogohan.com/recipe OR site:www.orangepage.net/recipes/ -site:orangepage.net/recipes/search/ -の検索結果 -のまとめ';
      break;
    case "KyounoRyouri":
      url += ' site:kyounoryouri.jp/recipe/';
      break;
    case "OrangePage":
      url += ' site:www.orangepage.net/recipes -orangepage.net/recipes/search/';
      break;
    default:
      url += ' site:kurashiru.com/recipes OR site:kyounoryouri.jp/recipe/ OR site:oceans-nadia.com/user/ OR site:sirogohan.com/recipe OR site:www.orangepage.net/recipes/ -site:orangepage.net/recipes/search/ -の検索結果 -のまとめ';
  }

  const flattenedData = Array.isArray(data) ? data.flat(Infinity).sort() : [];
  const newEntry = { str: str.trim(), data: flattenedData };

  const existingHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];
  
  // 重複チェック
  const duplicateIndex = existingHistory.findIndex(item => {
    const itemStr = (item.str || "").trim().toLowerCase();
    const newStr = newEntry.str.toLowerCase();
    const itemData = JSON.stringify((item.data || []).flat(Infinity).sort());
    const newData = JSON.stringify(flattenedData);
    return itemStr === newStr && itemData === newData;
  });

  if (duplicateIndex !== -1) {
    // 既存の重複項目を削除
    existingHistory.splice(duplicateIndex, 1);
  }

  // 新しいエントリを先頭に追加
  existingHistory.unshift(newEntry);

  // 履歴を10件に制限
  const updatedHistory = existingHistory.slice(0, 10);
  localStorage.setItem('searchHistory', JSON.stringify(updatedHistory));

  window.open(url);

  const databaseword = { selectedwords: mappedword, typedwords: str, time: dbtime };
  db.collection('word').doc().set(databaseword);
};
  const onKeyDown = (e) => { // onKeyPress から onKeyDown に変更
    if (e.key === 'Enter') {
      e.preventDefault();
      search();
    }
  };

  return (
    <div>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>
          {data.length > 0 && (
            <span style={{
              backgroundColor: "tomato",
              color: "white",
              fontFamily: `"Hiragino Kaku Gothic ProN", "メイリオ", "Meiryo", "MS PGothic", sans-serif`,
            }}>{data.join(' ')}</span>
          )}
        </span>
        {data.length > 0 && (
          <span
            id="allclear"
            onClick={clearSelection}
            style={{ cursor: 'pointer', marginLeft: 'auto' }}
          >
            <div
              style={{
                position: 'relative',
                fontSize: '1.2rem',
                marginLeft: '0.5rem',
                marginRight: '0.5rem'
              }}
            >戻す⏪
            </div>
          </span>
        )}
      </div>
      <div>
        <input
          name="searchbox"
          type="text"
          id="searchword"
          onChange={onChange}
          onKeyDown={onKeyDown} // onKeyDown を使用
          value={str}
          style={{ height: '40px' }}
          placeholder="🔍食材名や料理名をここに入力！"
        />
        <input
          className='submitinput'
          type="submit"
          value="🔍検索"
          id="searchbutton"
          onClick={search}
        />
      </div>
      <span style={{ backgroundColor: "white", borderRadius: "5px", padding: "1px" }}>
        <label style={{ color: "#ff9933", fontSize: "1rem", marginRight: "0.3rem", position: "static", }}>
          <input type="radio" checked={selectedSite === "Cookpad"} id="Cookpad" name="drone" value="Cookpad" onChange={handleOptionChange} />
          クックパッド
        </label>

        <label style={{ color: "#543614", fontSize: "1rem", marginRight: "0.3rem", position: "static" }}>
          <input type="radio" checked={selectedSite === "Nadia"} id="Nadia" name="drone" value="Nadia" onChange={handleOptionChange} />
          ナディア
        </label>

        <label style={{ color: "#de6043", fontSize: "1rem", marginRight: "0.3rem", position: "static" }}>
          <input type="radio" checked={selectedSite === "Kurashiru"} id="Kurashiru" name="drone" value="Kurashiru" onChange={handleOptionChange} />
          クラシル
        </label>



        <label style={{ color: "#c5a57a", fontSize: "1rem", marginRight: "0.3rem", position: "static", }}>
          <input type="radio" checked={selectedSite === "Pro"} id="Pro" name="drone" value="Pro" onChange={handleOptionChange} />
          Pro
        </label>

        {/* ドロップダウンメニューの追加 */}
        <label style={{ color: "gray", fontSize: "1rem", marginRight: "0.3rem", position: "static" }} onClick={toggleDropdown}>＋</label>
        {isDropdownOpen && (
          <span>
            <label style={{ color: "black", fontSize: "1rem", marginRight: "0.3rem", position: "static", }}>
              <input type="radio" checked={selectedSite === "Siro"} id="Siro" name="drone" value="Siro" onChange={handleOptionChange} />
              白ごはん
            </label>
            <label style={{ color: "#d5446f", fontSize: "1rem", marginRight: "0.3rem", position: "static", fontFamily: "Roboto" }}>
              <input type="radio" checked={selectedSite === "KyounoRyouri"} id="KyounoRyouri" name="drone" value="KyounoRyouri" onChange={handleOptionChange} />
              今日の料理
            </label>
            <label style={{ color: "#ed702d", fontSize: "1rem", marginRight: "0.3rem", position: "static", fontFamily: "Roboto" }}>
              <input type="radio" checked={selectedSite === "OrangePage"} id="OrangePage" name="drone" value="OrangePage" onChange={handleOptionChange} />
              オレンジページ
            </label>
          </span>
        )}
      </span>
      {/* サジェスト表示部分があれば追加 */}
      {
        suggestions.length > 0 && (
          <div className="suggestions">
            {suggestions.map((suggestion, index) => (
              <div
                key={index}
                className="suggestion-item"
                onClick={() => handleSuggestionClick(suggestion)}
              >
                {suggestion}
              </div>
            ))}
          </div>
        )
      }
    </div >
  );
};

export default Searchbar;